/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AddMedicalEventDto
 */
export interface AddMedicalEventDto {
    /**
     * 
     * @type {string}
     * @memberof AddMedicalEventDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AddMedicalEventDto
     */
    'durationSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddMedicalEventDto
     */
    'eventCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddMedicalEventDto
     */
    'eventType'?: AddMedicalEventDtoEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddMedicalEventDto
     */
    'occurrenceTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof AddMedicalEventDto
     */
    'patientSeizureTypeId'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum AddMedicalEventDtoEventTypeEnum {
    Seizure = 'SEIZURE',
    Menstruation = 'MENSTRUATION',
    Infection = 'INFECTION',
    SleepDeprivation = 'SLEEP_DEPRIVATION',
    Fever = 'FEVER',
    PregnancyOrPrePregnancyPeriodStart = 'PREGNANCY_OR_PRE_PREGNANCY_PERIOD_START',
    PregnancyOrPrePregnancyPeriodEnd = 'PREGNANCY_OR_PRE_PREGNANCY_PERIOD_END',
    VnsStimulatorImplantation = 'VNS_STIMULATOR_IMPLANTATION',
    Other = 'OTHER'
}


